import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Container, Row, Col, Button } from 'react-bootstrap';
import styles from '../../styles/common/searchresult.module.css';
import { useNavigate } from 'react-router-dom';

// interface AmazonItem {
//     ASIN: string;
//     DetailPageURL: string;
//     Images: {
//         Primary: {
//             Medium: {
//                 URL: string;
//                 Height: number;
//                 Width: number;
//             };
//         };
//     };
//     ItemInfo: {
//         Title: {
//             DisplayValue: string;
//             Label: string;
//             Locale: string;
//         };
//     };
// }

const SearchResult: React.FC = () => {
    const navigate = useNavigate();
    // const items = useSelector((state: RootState) => state.amazon.items) as AmazonItem[];
    const { items, loading } = useSelector((state: RootState) => state.amazon);

    return (
        // <Container className={styles.container}>
        //     <h3 className={styles.title}>Search Results</h3>
        //     <Row>
        //         {items.length === 0 ? (
        //             <Col>
        //                 <p className={styles.noResult}>No results found.</p>
        //             </Col>
        //         ) : (
        //             items.map((item, index) => {
        //                 const image = item?.Images?.Primary?.Medium?.URL;
        //                 const title = item?.ItemInfo?.Title?.DisplayValue;
        //                 const url = item?.DetailPageURL;

        //                 return (
        //                     <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
        //                         <Card className={styles.card}>
        //                             {image && (
        //                                 <Card.Img
        //                                     variant="top"
        //                                     src={image}
        //                                     alt={title}
        //                                     className={styles.image}
        //                                 />
        //                             )}
        //                             <Card.Body className="d-flex flex-column">
        //                                 <Card.Title className={styles.cardTitle}>
        //                                     {title?.length > 90 ? `${title.substring(0, 90)}...` : title}
        //                                 </Card.Title>
        //                                 <Button
        //                                     variant="success"
        //                                     href={url}
        //                                     target="_blank"
        //                                     rel="noopener noreferrer"
        //                                     className={styles.buyBtn}
        //                                 >
        //                                     Buy Now
        //                                 </Button>
        //                             </Card.Body>
        //                         </Card>
        //                     </Col>
        //                 );
        //             })
        //         )}
        //     </Row>
        // </Container>
        <Container className="py-4">
            <h4 className="mb-4">Search Results</h4>
            <Row>
                {loading ? (
                    <Col>
                        <div className={styles.emptyState}>
                            <strong>Finding products for you…</strong>
                            <span>Please wait while we load the latest search results.</span>
                        </div>
                    </Col>
                ) : !items?.length ? (
                    <Col>
                        <div className={styles.emptyState}>
                            <div className={styles.emptyIcon}>⌕</div>
                            <strong>We couldn't find products for that search</strong>
                            <span>Try browsing the catalogue instead. New products published by the admin appear there automatically.</span>
                            <div className={styles.emptyActions}>
                                <Button onClick={() => navigate("/products")}>Browse catalogue</Button>
                                <Button variant="light" onClick={() => navigate("/")}>Back home</Button>
                            </div>
                        </div>
                    </Col>
                ) : (
                    items.map((item: any, index: number) => {
                        const image = item?.Images?.Primary?.Medium?.URL;
                        const title = item?.ItemInfo?.Title?.DisplayValue;
                        const url = item?.DetailPageURL;
                        const asin = item?.ASIN;

                        return (
                            <Col key={index} xs={12} className="mb-4">
                                <div className={styles.cardWrapper}>
                                    <img
                                        src={image}
                                        alt={title}
                                        className={styles.image}
                                    />
                                    <div className={styles.content}>
                                        <div className={styles.title}>
                                            {title}
                                        </div>
                                        <div className={styles.content}>
                                            <span>ASIN: {asin}</span>
                                        </div>
                                        <Button
                                            variant="warning"
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={styles.buyButton}
                                        >
                                            Buy Now
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        );
                    })
                )}
            </Row>
        </Container>
    );
};

export default SearchResult;
